import React from "react";
import { steps } from "../data/content";
import { CtaButton } from "./ui/CtaButton";
import { Accent, SectionHeading } from "./ui/SectionHeading";
export function Steps() {
  return <section className="bg-blush px-4 py-14 sm:px-6 sm:py-20" data-id="element-157" data-mp="umy8k6xw36n7">
      <SectionHeading title={<>
            La tua prima creazione,
            <span className="block" data-id="element-159" data-mp="ymgwzcox5zus">
              <Accent italic data-id="element-160" data-mp="kosak0f7eknm">a tre passi da te.</Accent>
            </span>
          </>} data-id="element-158" data-mp="uklw29awhohj" />
      <ol className="mx-auto mt-10 grid max-w-6xl gap-5 md:grid-cols-3" data-id="element-161" data-mp="pnbzm9p3gck7">
        {steps.map(({
        icon: Icon,
        title,
        body
      }, i) => <li key={title} className="flex flex-col rounded-[28px] border border-line bg-cream p-6 shadow-[0_14px_30px_-24px_rgba(86,18,54,0.45)] sm:p-7" data-id="element-162" data-mp="bovpe8s0w3xb" data-mpi={i}>
            <Icon className="mx-auto h-12 w-12 text-rose" strokeWidth={1} aria-hidden="true" data-id="element-163" data-mp="262wpsy380yzi" />
            <h3 className="mt-6 font-serif text-[24px] font-semibold leading-tight text-wine" data-id="element-164" data-mp="2a3qehtohmhtg">
              <span className="text-rose" data-id="element-165" data-mp="1qakcimf4qzid">{i + 1}.</span> {title}
            </h3>
            <p className="mt-3 text-[15px] leading-relaxed text-ink sm:text-base" data-id="element-166" data-mp="1lcir3uu8eo3q">{body}</p>
          </li>)}
      </ol>
      <div className="mt-10 flex justify-center" data-id="element-167" data-mp="2003u7or3wnbn">
        <CtaButton data-id="element-168" data-mp="202zrrbz1l9zk">Sono pronta a iniziare!</CtaButton>
      </div>
    </section>;
}